import { render } from "./scrollspy.vue?vue&type=template&id=4c08c84f"
import script from "./scrollspy.vue?vue&type=script&lang=js"
export * from "./scrollspy.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__